import { useContext } from "react";
import context from "../state/context";
import IGlobalContextProvider from "../state/types";

export default (): IGlobalContextProvider => useContext(context);
